import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dispatcher, RootState } from 'AppTypes'
import { fetchCameraList, fetchLiveStreamSettings } from '@features/live_stream/state_management/actions'

import LiveStreamSettings from './partials/LiveStreamSettings'
import CameraInfo from './partials/CameraInfo'

import './LiveStream.css'

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  doFetchLiveStreamSettings: () => dispatch(fetchLiveStreamSettings()),
  doFetchCameraList: (pageIndex: number, pageSize: number) => {
    dispatch(fetchCameraList({ pageIndex, pageSize }))
  }
})

const mapStateToProps = (state: RootState) => ({
  settings: state.liveStream.liveStreamSettings,
  cameras: state.liveStream.cameras,
  pageIndex: state.liveStream.pageIndex,
  pageSize: state.liveStream.pageSize
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const LiveStream: React.FC<Props> = ({
  cameras,
  pageIndex,
  pageSize,
  doFetchCameraList,
  doFetchLiveStreamSettings
}) => {
  const { t } = useTranslation()

  // didMounted
  useEffect(() => {
    doFetchLiveStreamSettings()
    doFetchCameraList(pageIndex, pageSize)
  }, [])

  return (
    <div className="main-content">
      <div>
        <div className="row">
          <h2 className="col">{t('liveStream.pageTitle')}</h2>
        </div>
        <LiveStreamSettings />
      </div>
      <div className="mt-4">
        <div className="row">
          <h2 className="col">{t('liveStream.cameraListTitle')}</h2>
        </div>
        {cameras
          && cameras.length > 0
          && cameras.map((camera, index) => <CameraInfo camera={camera} key={camera.id} index={index} />)}
      </div>
    </div>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStream)
